import { getTagAttributes } from "@bkry/bowline-redux/tags";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Badge } from "reactstrap";

const TribeTag = ({ tagId }) => {
  const tagData = useSelector((state) => getTagAttributes(state, tagId));
  if (!tagData) return null;
  return (
    <Badge
      color="white"
      className="text-dark px-3"
      style={{ marginRight: "4px", borderRadius: "8px" }}
    >
      {tagData?.name}
    </Badge>
  );
};

TribeTag.propTypes = {
  tagId: PropTypes.string.isRequired,
};

TribeTag.defaultProps = {};

export default TribeTag;
